// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".embeded-btn{text-align:center}@media (max-width: 360px){.hero-grid-button{position:relative;top:7px}}\n", ""]);
// Exports
module.exports = exports;
